import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "./baseQuery";
import { compose } from "@reduxjs/toolkit";
import { result } from "lodash";
import { updateToken } from "./slices/profile";

export const authApi = createApi({
	reducerPath: "auth",
	baseQuery: axiosBaseQuery(),

	endpoints: (builder) => ({
		registerUser: builder.mutation<any, any>({
			query: (data: any) => ({
				url: `/auth/register`,
				method: "POST",
				data,
			}),
		}),

		loginUser: builder.mutation<any, { email: string; password: string }>({
			query: (data: any) => ({
				url: `/auth/login`,
				method: "POST",
				data,
			}),
		}),
		getRegisterUser: builder.query<any, void>({
			query: (data: void) => ({
				url: `/auth/get-user-profile`,
				method: "GET",

			}),
			transformResponse: (result: any) => {
				console.log(result, "check result")
				const user = {
					firstName: result.data.firstName,
					lastname: result.data.lastName,
					email: result.data.email,
					contactNo: result.data.contactNo,
					region: result.data.region,
					address: result.data.address,
					profilePic: result.data.profilePic,
					isAdmin: result.data.isAdmin
				}
				return user

			}
		}),

		editRegisterUser: builder.mutation<any, any>({
			query: (data: any) => ({
				url: `/auth/edit-profile`,
				method: "POST",
				data,
				headers: {
					'Content-Type': 'multipart/form-data',
				}
			}),
		}),
		forgetPassword: builder.mutation<any, any>({
			query: (data: any) => ({
				url: `/auth/forget-password`,
				method: "POST",
				data,
			}),
		}),

		verifyEmail: builder.query<any, any>({
			query: ({ token }: any) => ({
				url: `/auth/verify-email`,
				method: "GET",
				headers: { 'authorization': token }
			}),
		}),

		resetPassword: builder.mutation<any, any>({
			query: (data: any) => ({
				url: `/auth/reset-password`,
				method: "POST",
				data,
				headers: { 'authorization': data?.token }
			}),
		}),
	}),
})


export const {
	useRegisterUserMutation,
	useLoginUserMutation,
	useGetRegisterUserQuery,
	useEditRegisterUserMutation,
	useForgetPasswordMutation,
	useVerifyEmailQuery,
	useResetPasswordMutation,
} = authApi;
